import ledgerAccountCategoryIds from './ledgerAccountCategoryIds';
import ledgerAccountCategoryTypes from './ledgerAccountCategoryTypes';

const ledgerAccountCategoryTypeById = {
  [ledgerAccountCategoryIds.ASSETS]: ledgerAccountCategoryTypes.BALANCE_SHEET,
  [ledgerAccountCategoryIds.LIABILITIES]: ledgerAccountCategoryTypes.BALANCE_SHEET,
  [ledgerAccountCategoryIds.EQUITY]: ledgerAccountCategoryTypes.BALANCE_SHEET,
  [ledgerAccountCategoryIds.REVENUE]: ledgerAccountCategoryTypes.INCOME_STATEMENT,
  [ledgerAccountCategoryIds.COST_OF_SALES]: ledgerAccountCategoryTypes.INCOME_STATEMENT,
  [ledgerAccountCategoryIds.OPERATING_EXPENSES]: ledgerAccountCategoryTypes.INCOME_STATEMENT,
};

export default ledgerAccountCategoryTypeById;
